export default __webpack_public_path__ + "static/media/Wham-LastChristmas.a9cd3d1f.mp3";